import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';

export const ColStyled = styled(Col)`
  ${({ theme, disableBottomPadding }) => {
    const mediumUp = theme.mediumUp();
    let thisPaddingBottom = mediumUp ? rem(32) : rem(10);

    if(disableBottomPadding) {
      thisPaddingBottom = 0;
    }

    return css`
      && {
        :nth-child(-n + ${mediumUp ? 2 : 3}) {
          padding-bottom: ${thisPaddingBottom};
        }
      }
    `;
  }}
`;

export const ColStyledButtonContainer = styled(Col)`
  text-align: center;
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(40) : rem(32)};
    `;
  }}
`;
